import { IPrimeirosPassos } from './settings_primeiros_passos';

/**
 * MODULOS:
 * - FINANCEIRO
 */
export class SettingsPrimeirosPassosFinanceiro {
  passos = [
    {
      posicao: null,
      passo_valor: 'INFO_FINANCEIRO',
      titulo: 'TESTE FINANCEIRO',
      descricao: 'Teste',
      concluido: false
    },
  ] as IPrimeirosPassos[];

  ultimo_passo = 'UNKNONW';

  constructor(
    public configInicial: {
      passos: IPrimeirosPassos[];
      ultimo_passo: string;
    }
  ) {
    var count = 0;
    this.passos.forEach(it => {
      const index = configInicial.passos.findIndex(
        it2 => it2.passo_valor === it.passo_valor
      );
      if (index === -1) {
        configInicial.passos.push(it);
      }
    });
    configInicial.passos.forEach(it => {
      if(it.posicao !== null) count = it.posicao + 1;
      it.posicao = it.posicao !== null ? it.posicao : count++
    });
    this.passos = configInicial.passos;
    this.ultimo_passo = configInicial.ultimo_passo;
  }

  getSettingsPassosFinanceiro(config_inicial: {
    passos: IPrimeirosPassos[];
    ultimo_passo: string;
  }) {
    return {
      passos: this.passos,
      ultimo_passo: this.ultimo_passo
    };
  }
}
